/* eslint-disable sonarjs/no-duplicated-branches */
/* eslint-disable sonarjs/no-all-duplicated-branches */
/* eslint-disable @next/next/inline-script-id */
/* eslint-disable import/no-extraneous-dependencies */
import { lazy, PropsWithChildren, Suspense, useEffect, useState } from 'react';
import { SkeletonTheme } from 'react-loading-skeleton';
import { ToastContainer } from 'react-toastify';
import App from 'next/app';
import Router from 'next/router';
import Script from 'next/script';
import { SessionProvider, signOut } from 'next-auth/react';
import { cacheExchange, Client, fetchExchange, Provider } from 'urql';
import { CookiesProvider } from 'react-cookie';
import Toast from '@/components/Common/Toast';
import LoadingPage from '@/components/Common/LoadingPage';
import InviteFriendModal from '@/components/2d-game/InviteFriendModal/InviteFriendModal';
import SignWithReferralModal from '@/components/Referral/_signupWithReferralModal';
import { _getMetaTags } from '@/service/service';
import { GTMPageView } from '@/utils/gtm';
import { useRouter } from 'next/router';
import { TolgeeProvider, DevTools, Tolgee, FormatSimple, useTolgeeSSR, BackendFetch } from '@tolgee/react';
import '../styles/globals.scss';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/fonts.css';
import React from 'react';
import Cookies from 'js-cookie';
import LayoutPage from '@/components/Common/LayoutPage';
import dynamic from 'next/dynamic';
import ItemInformationSuccess from '@/components/Blueprint/components/Modals/ItemInformationSuccess';
// import ContextProvider from '@/components/appkit/appkit-context-provider';

// const ContextProvider = lazy(() => import('@/components/appkit/appkit-context-provider'));
const ContextProvider = dynamic(() => import('@/components/appkit/appkit-context-provider'), { ssr: true });

const AblySocketConfig = dynamic(() => import('@/components/AblySocketConfig/AblySocketConfig'), { ssr: false });

// Cookie Consent component - using inline Tailwind styles
const CookieConsent = dynamic(() => import('@/components/CookieConsent/CookieConsent'), { ssr: false });

export const tolgee = Tolgee()
  .use(
    BackendFetch({
      prefix: 'https://localization.landrocker.io/29f699007b2916f93ee889b4c16485c9',
      getPath: ({ prefix, language }) => {
        return `${prefix}/${language}.json`;
      },
    }),
  )
  .use(DevTools())
  .use(FormatSimple())
  .init({
    defaultLanguage: 'en',
    availableLanguages: ['en', 'ru', 'pt', 'tr', 'id', 'fr', 'es', 'de', 'sw', 'fil', 'vi', 'ar', 'it', 'ja', 'nl', 'uk', 'zh', 'tl', 'hi', 'th'],
  });

// theGraph client mainnet
const client = new Client({
  // url: 'https://main-graph.landrocker.io/subgraphs/name/landrocker_io/',
  url: 'https://api.studio.thegraph.com/query/71429/landrocker_io/version/latest',
  exchanges: [cacheExchange, fetchExchange],
});

const MyApp = ({ Component, pageProps, metaTags }: { Component: any; pageProps: any; metaTags?: any }) => {
  const router = useRouter();
  const ssrTolgee = useTolgeeSSR(tolgee, router.locale);
  const [loading, SetLoading] = useState(false);
  const [cookieConsent, setCookieConsent] = useState<boolean | null>(null);
  
  useEffect(() => {
    // Check if cookie consent exists on client side
    if (typeof window !== 'undefined') {
      const hasConsent = Cookies.get('cookieConsent');
      setCookieConsent(hasConsent === 'accepted' || hasConsent === 'all');
    }
  }, []);

  useEffect(() => {
    const handleRouteChange = (url: string) => GTMPageView(url);
    Router.events.on('routeChangeStart', (url) => {
      if (url.includes('assetType=')) {
      } else {
        SetLoading(true);
        handleRouteChange(url);
      }
    });

    Router.events.on('routeChangeComplete', (url) => {
      SetLoading(false);
      handleRouteChange(url);
    });

    if (typeof window !== 'undefined') {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    (async () => {
      if (typeof window !== 'undefined') {
        const newAuth = localStorage.getItem('newAuth');

        if (newAuth === undefined || newAuth === null) {
          ['next-auth.session-token', 'next-auth.csrf-token', 'next-auth.callback-url', 'next-auth.redirect-url', 'next-auth.state'].forEach(
            (cookie) => {
              Cookies.remove(cookie);
            },
          );
          try {
            await signOut({ redirect: false, callbackUrl: '/' });
          } catch (error) {
          } finally {
            localStorage.setItem('newAuth', 'true');
          }
        }
      }
    })();
  }, []);

  // Cookie consent handler
  const handleAcceptCookies = () => {
    Cookies.set('cookieConsent', 'accepted', { expires: 365 });
    setCookieConsent(true);
  };

  const res = (
    <SkeletonTheme baseColor='#202020' highlightColor='#444'>
      {/* <Provider createStore={createStore}> */}
      <LayoutPage metaTags={metaTags}>
        {loading && <LoadingPage />}
        <Component {...pageProps} />

        <ToastContainer limit={1} newestOnTop={true} />
        <Toast />
        <InviteFriendModal />
        <AblySocketConfig />
        <ItemInformationSuccess />
        <SignWithReferralModal />
        
        {/* Cookie Consent Banner */}
        {cookieConsent === false && <CookieConsent onAccept={handleAcceptCookies} />}

        {/* <NFTSuccessModal /> */}
      </LayoutPage>
      {/* </Provider> */}
    </SkeletonTheme>
  );

  return (
    <>
      {/* Only load analytics scripts if analytics consent is given */}
      {cookieConsent && (
        <>
          <Script strategy='afterInteractive' src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS}`} />

          <Script strategy='afterInteractive'>
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS}', {
              page_path: window.location.pathname,
              });
            `}
          </Script>
          <Script
            id='twitter-pixel'
            strategy='afterInteractive'
            dangerouslySetInnerHTML={{
              __html: `!function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
                },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',
                a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
                twq('config','ohm9s');`,
            }}
          />
        </>
      )}
      
      <CookiesProvider>
        <TolgeeProvider tolgee={ssrTolgee} fallback={<LoadingPage />}>
          <SessionProvider refetchOnWindowFocus={false} session={pageProps.session}>
            <Provider value={client}>
              {/* <Suspense fallback={ <>{res}</>}> */}
              {/* <Suspense fallback={<div>{res}</div>}> */}
              <ContextProvider>{res}</ContextProvider>
              {/* </Suspense> */}
            </Provider>
          </SessionProvider>
        </TolgeeProvider>
      </CookiesProvider>
    </>
  );
};

const fallbackMetaImage = 'https://cdn.landrocker.io/website_content/landing/metatag/Immutable_poster%20Version_04.png';

MyApp.getInitialProps = async (appContext) => {
  let metaTags = {
    title: 'LandRocker',
    description:
      'LandRocker is a play-to-earn game about discovery and space exploration where players compete to uncover valuable resources such as NFTs, crypto tokens, crafting materials and more.',
    imageUrl: fallbackMetaImage,
    isHome: false,
  };
  const appProps = await App.getInitialProps(appContext);

  return { ...appProps, metaTags };
};
// export default appWithTranslation(MyApp, nextI18nextConfig);
export default MyApp;